import React, { FC, memo, useImperativeHandle, useRef } from 'react';
import { useMount } from 'ahooks';
import { isNumber } from 'src/util/core';

interface TemplateProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
    forwardRef?: React.RefObject<any>;
    onTimeChange?: (currentTime?: number) => void;
    onPlay?: () => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { forwardRef, onTimeChange, onPlay, src, ...restProps } = props || {};

    const ref = useRef<HTMLVideoElement>(null);

    const play = (currentTime?: number) => {
        if (ref.current) {
            ref.current.currentTime = currentTime || 0;
            ref.current.play();
        }
    };

    const pause = () => {
        if (ref.current) {
            ref.current.pause();
        }
    };

    const isVideoPaused = () => {
        if (ref.current) {
            return ref.current.paused;
        } else {
            return true;
        }
    };

    const updateCurrentTime = (currentTime: number) => {
        if (ref.current && ref.current.paused && isNumber(currentTime)) {
            ref.current.currentTime = currentTime;
        }
    };

    useImperativeHandle(forwardRef, () => {
        return {
            play,
            pause,
            isVideoPaused,
            updateCurrentTime,
        };
    });

    useMount(() => {
        if (ref.current) {
            ref.current.ontimeupdate = () => {
                onTimeChange?.(ref.current?.currentTime);
            };

            ref.current.onplay = () => {
                onPlay?.();
            };
        }
    });

    return (
        <video src={src} style={{ width: 280, height: 140 }} controls {...restProps} ref={ref} />
    );
});

export default Template;
